import { Box, Button, FormHelperText, Stack } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import DlspFieldQAForm from "./DlspFieldQAForm"
import { FieldQADetails } from "./FieldQADetails"
import useFetchJson from "../../../data/useFetchJson"
import { LoadingBox } from "@northpowerdev/np-react-utils"
import { MahiContext, mahiNameFromMahiContext } from "../../state/MahiContext"

export function DlspFieldQAPanel({taskDetails, assignee, onEdited, userName, isQARole, fspStatusNoEdit}) {
    const [isEditing, setIsEditing] = useState(false)
    const [qaOwner, setQAOwner] = useState('')
    const mahiContext = useContext(MahiContext)

    const claimDesktopQAPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/claim-desktop-qa-ownership'
    const {
        isLoading: isClaimingFieldQA,
        load: claimFieldQA} = useFetchJson(claimDesktopQAPath, {method: 'POST'}) 

    useEffect(() => {
        if (!taskDetails) {
            return
        }
        setQAOwner(taskDetails.decomICP?.desktopQAOwner || '')
    }, [taskDetails])
    
    const fieldQAButtonLabel = taskDetails?.decomICP?.fieldQA 
        ? "Edit Field QA"
        : "Create Field QA"

    const handleFieldQAFormEdited = () => {
        setIsEditing(false)
        onEdited() // tell parent the assessment form has been edited (even though it might just have been closed)
    }

    const handleFieldQAEditStart = async () => {
        const fetchParams = { params: { icp: taskDetails.decomICP.icp  } }
        const claimedOK = await claimFieldQA(fetchParams)
        if (claimedOK !== undefined) {
            const mahiName = mahiNameFromMahiContext(mahiContext)
            setIsEditing(true)
            setQAOwner(mahiName)
        }
    }

    const isQAOtherOwner = qaOwner && qaOwner !== userName
    const qaButtonHelperText = qaOwner ? `Owned by ${qaOwner}` : ''
    return (
        <Box>
            {
                isEditing
                ?
                <DlspFieldQAForm
                    fieldQADetails={taskDetails?.decomICP?.fieldQA}
                    statusHistory={taskDetails?.statusHistory}
                    icpNumber={taskDetails?.decomICP?.icp}
                    assignee={assignee}
                    onClose={handleFieldQAFormEdited}
                    />
                :
                <>
                    <FieldQADetails
                        fieldQA={taskDetails?.decomICP?.fieldQA}
                        desktopQAOwner={qaOwner}
                        desktopQABy={taskDetails?.decomICP?.desktopQABy}
                        desktopQADate={taskDetails?.decomICP?.desktopQADate}
                    />
                    <LoadingBox loading={isClaimingFieldQA} message="Checking ownership...">
                        <Stack direction="row" justifyContent="space-between">
                            <Button variant="contained" disabled={!isQARole || isQAOtherOwner || fspStatusNoEdit} sx={{my:1}} color="primary" onClick={handleFieldQAEditStart} >
                                {fieldQAButtonLabel}
                            </Button>
                            {
                                isQARole
                                &&
                                <Button variant="text" sx={{my:1}} color="secondary" disabled={fspStatusNoEdit} onClick={handleFieldQAEditStart} >
                                    Become QA Owner
                                </Button>
                            }
                        </Stack>
                    </LoadingBox>


                </>
            }
            {
                qaButtonHelperText
                &&
                <FormHelperText>{qaButtonHelperText}</FormHelperText>
            }
        </Box>
    )
}
